export default "__VITE_ASSET__4VMXdyBQ__"